export default "__VITE_ASSET__DXYaf_PB__"